import url from "url";
import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { get_auth_cookie, set_auth_cookie, get_refresh_cookie, remove_auth_cookie } from "../helpers/auth";


const DEBUG_ENABLED = parseInt(process.env.VUE_APP_DEBUG);


function reqeuestLoggingMiddleware(request){
  return request;
}


function responseLoggingMiddleware(response){
  return response;
}


const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    BUILDNO: process.env.VUE_APP_BUILD_NO,
    "Content-Type": "application/json"
  }
});


instance.interceptors.request.use(function(config) {
  const token = get_auth_cookie();
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});


// Function that will be called to refresh authorization
const refreshAuth = failedRequest =>
  axios
    .post(
      url.resolve(
        process.env.VUE_APP_BASE_API_URL,
        "auth/get_new_access_token"
      ),
      {
        refresh_token: get_refresh_cookie()
      }
    )
    .then(tokenRefreshResponse => {
      let access_token = tokenRefreshResponse.data.access_token;
      set_auth_cookie(access_token)
      failedRequest.response.config.headers["Authorization"] =
        "Bearer " + access_token;
      return Promise.resolve();
    });

// Check if user is restricted before setting the tokens
const isRestricted = () => {
  instance.get("user_info/get_user_info")
  .then(response => response.data)
  .catch((error) => {
    let errorMessage = error?.response?.data?.error_message

    if (error.response && (errorMessage == "ACCESS_RESTRICTED" || errorMessage == "INVALID_ACCESS_TOKEN" || errorMessage == "UNCONFIRMED_ACCESS_RESTRICTED")) { // user is restricted or token is invalid
      let redirectURL = process.env.VUE_APP_UHIVE_MAIN_SITE + "web/logout?msg=access_restricted"

      remove_auth_cookie();
      window.location = redirectURL;
    } else {
      console.error("Error fetching isRestricted:", error);
    }
  });
};
isRestricted()

createAuthRefreshInterceptor(instance, refreshAuth);


if (DEBUG_ENABLED) {
  axios.interceptors.request.use(reqeuestLoggingMiddleware);
  axios.interceptors.response.use(responseLoggingMiddleware);
  instance.interceptors.request.use(reqeuestLoggingMiddleware);
  instance.interceptors.response.use(responseLoggingMiddleware);
}


export default instance;
